import React, { useRef, useCallback, useMemo } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import OccupancyPicker from 'components/Common/OccupancyPicker/OccupancyPicker'
import { mediaQueryUp } from 'components/utils/breakpoint'
import config from 'constants/config'

const OccupancyContainer = styled.div`
  width: 100%;
  flex-grow: 0;
  display: flex;
  gap: ${rem(24)};
  flex-direction: column;
  padding: 0 ${rem(16)};

  ${mediaQueryUp.tablet} {
    padding: 0;
  }
`

const CruiseOccupancyPicker = styled(OccupancyPicker)`
  > :last-child {
    display: flex;
    justify-content: end;
    padding-bottom: ${rem(16)}
  }
`
interface Props {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
  occupancies: Array<App.Occupants>;
  shipOccupancies: App.CruiseShipOccupancy;
  onOccupanciesChange: (occupacies: Array<App.Occupants>) => void;
}

function TravelerSelectionModal(props: Props) {
  const {
    isOpen,
    occupancies,
    shipOccupancies,
    onClose,
    onContinue,
    onOccupanciesChange,
  } = props

  const formRef = useRef<HTMLFormElement>(null)

  const onSubmit = useCallback(
    (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault()
      onContinue()
    }, [onContinue])

  const capacities = useMemo((): App.PackageRoomCapacity[] => ([{
    adults: shipOccupancies.maxAdults,
    infants: shipOccupancies.maxInfants,
    children: shipOccupancies.maxChildren,
    total: shipOccupancies.maxOccupancy,
  }]), [shipOccupancies])

  return (
    <ModalBase
      size="large"
      isOpen={isOpen}
      onClose={onClose}>

      <ModalHeader
        title="Who’s coming?"
        onCloseButtonClick={onClose} />

      <OccupancyContainer>
        <form ref={formRef} onSubmit={onSubmit}>
          <CruiseOccupancyPicker
            submit
            maxRooms={1}
            saleUnit="cabin"
            applyText="Continue"
            capacities={capacities}
            occupancies={occupancies}
            childrenAgeLabel="at time of departure"
            maxChildAge={shipOccupancies.childMaximumAge}
            maxInfantAge={shipOccupancies.infantMaximumAge}
            onChange={onOccupanciesChange}
            enableMultiRoom={config.accommodation.allowsMultiRoom}
          />
        </form>
      </OccupancyContainer>
    </ModalBase>
  )
}

export default TravelerSelectionModal
